import React, { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import SupervisorApi from "../../utility/supervisorApi";
import { HexColorPicker } from "react-colorful";

function AddNewStore() {
  const { createData } = SupervisorApi();
  const [color, setColor] = useState("#b32aa9");
  const [, setColorCode] = useState(false);
  // State to hold form data
  const [formData, setFormData] = useState({
    store_name: "",
    location: "",
    color_code: "",
    email: "",
    password: "",
  });

  const addStore = useMutation({
    mutationFn: (formData) =>
      createData("/store-management/store", formData, true),
    onSuccess: () => {
      // Handle success (e.g., show a success message, reset form, etc.)
      setFormData({
        store_name: "",
        location: "",
        color_code: "",
        email: "",
        password: "",
      });
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      color_code: color,
    }));

    setColorCode(false);
  }, [color]);

  const handleSubmit = (e) => {
    e.preventDefault();
    addStore.mutate(formData);
  };

  return (
    <section className="min-w-full h-screen overflow-y-auto p-4 pb-20">
      <h2 className="text-2xl font-semibold mb-6">Add new store</h2>
      <form
        className="bg-white p-6 rounded-lg shadow-md space-y-6"
        onSubmit={handleSubmit}
      >
        <div>
          <h3 className="text-lg font-semibold mb-4">Store details</h3>
          <div className="space-y-4">
            <input
              name="store_name"
              className="w-full p-3 border rounded-md"
              placeholder="Enter store name"
              type="text"
              value={formData.store_name}
              onChange={handleChange}
            />
            <input
              name="location"
              className="w-full p-3 border rounded-md"
              placeholder="Enter your store's location"
              type="text"
              value={formData.location}
              onChange={handleChange}
            />
            <div className="flex flex-col items-start gap-4">
              <div>
                <h2 className="text-lg font-semibold mb-4">
                  Select Store Color code
                </h2>
              </div>
              <div className="group px-4 flex gap-5 justify-center items-center text-white rounded-md hover:cursor-pointer">
                <h2 className="text-black">Color Code</h2>
                <div
                  className="w-5   h-5 rounded-full"
                  style={{ backgroundColor: color }}
                ></div>
              </div>
              <div className="flex flex-col lg:flex-row items-center gap-4">
                <HexColorPicker color={color} onChange={setColor} />
              </div>
            </div>
          </div>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-4">
            Store admin credentials
          </h3>
          <div className="space-y-4">
            <input
              name="email"
              className="w-full p-3 border rounded-md"
              placeholder="Enter Admin's Email"
              type="email"
              value={formData.email}
              onChange={handleChange}
            />
            <div className="relative">
              <input
                name="password"
                className="w-full p-3 border rounded-md"
                placeholder="Enter Admin's password"
                type="password"
                value={formData.password}
                onChange={handleChange}
              />
              <div className="absolute inset-y-0 right-0 flex items-center px-2">
                <i className="fas fa-eye"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center space-x-4">
          <button
            className="px-6 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-600 hover:text-white"
            type="button"
            onClick={() =>
              setFormData({
                storeName: "",
                storeLocation: "",
                storeColor: "",
                adminUsername: "",
                adminPassword: "",
              })
            } // Reset form
          >
            Cancel
          </button>
          <button
            className="px-6 py-2 bg-black text-white rounded-md hover:bg-gray-900"
            type="submit"
          >
            Save
          </button>
        </div>
      </form>
    </section>
  );
}

export default AddNewStore;
